function resizeChildren() {
    const parentWidth = document.querySelector(".mega-menu__wrapper").offsetWidth;
    const firstChildWidth = document.querySelector(".mega-menu__list.mega-menu__list-layout_4--images").offsetWidth;

    const secondChildWidth = 232 - 49; //232 is ul width and 49 is padding that minus from ul and we can get actual width

    const thirdChildren = document.querySelectorAll(".mega-menu__inner-submenu--wrapper-parent");
    const thirdChildWidth = parentWidth - firstChildWidth - secondChildWidth;
    thirdChildren.forEach((thirdChild) => {
        thirdChild.style.width = thirdChildWidth + "px";
    });
    const megamenuHeight = document.querySelectorAll(".header__mega-menu.mega-menu");

    megamenuHeight.forEach((megamenuheight) => {
        const heightY = megamenuheight.offsetHeight;

        const megamenuParent = megamenuheight.closest('.header__mega-menu--wrapper');

        if (megamenuParent) {
            megamenuParent.style.height = `${heightY}px`;
        }
    });

}
resizeChildren();
window.addEventListener("resize", resizeChildren);

